import OrderService from "@/services/OrderService";
import { useState } from "react";
import { useMount } from "react-use";

// 순수 referral 로직은 서버 API route 와 공유하기 위해 분리됨. 기존 import 경로 유지를 위해
// re-export. docs/global-e-backend-contract.md §5.4.
export {
  REFERRAL_DISCOUNT_ITEMS,
  isReferralActiveForProduct,
} from "@/libs/referral/referral-items";
import { REFERRAL_DISCOUNT_ITEMS } from "@/libs/referral/referral-items";

export const useReferralDiscount = () => {
  const [referralDiscountPercentile, setReferralDiscountPercentile] =
    useState(0);

  useMount(() => {
    const referralDiscount = OrderService.tryGetReferralDiscountFromCookie();
    setReferralDiscountPercentile(referralDiscount);
  });

  return { referralDiscountPercentile, targetItems: REFERRAL_DISCOUNT_ITEMS };
};
